import { createQueryKeys } from '@lukemorales/query-key-factory';
import { type QueryClient, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { HttpService } from '@/features/api/http.service';
import { toastBackendError } from '@/features/api/utils/toastBackendError';
import type { IPagination, IProject } from '@/types/api';

// TODO: temporary, need to handle pagination
export interface ProjectPaginated {
  projects: IProject[];
  pagination: IPagination;
}

const PROJECTS_PATH = '/projects';

const PROJECTS_FACTORY_NAME = 'projects';

export const projectsKeyFactory = createQueryKeys(PROJECTS_FACTORY_NAME, {
  getAll: (page: number) => ({
    queryKey: [PROJECTS_PATH, page],
    queryFn: () => {
      return HttpService.get<string, ProjectPaginated>(
        `${PROJECTS_PATH}`,
        new URLSearchParams({ page: page.toString() }),
      );
    },
  }),
  getProject: (id: string) => ({
    queryKey: [PROJECTS_PATH, id],
    queryFn: () => HttpService.get<string, ProjectPaginated>(`${PROJECTS_PATH}/${id}`),
  }),
});

export async function invalidAllProjectQueries(queryClient: QueryClient) {
  await queryClient.invalidateQueries({
    queryKey: [PROJECTS_FACTORY_NAME],
  });
}

export function useProjectsQuery(page: number) {
  return useQuery(projectsKeyFactory.getAll(page));
}

export function useProjectQuery(id: string) {
  return useQuery(projectsKeyFactory.getProject(id));
}

export function useCancelProject() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ projectId }: { projectId: string }) =>
      HttpService.delete<Partial<IProject>, IProject>(`${PROJECTS_PATH}/${projectId}`),
    onSuccess: async () => {
      await invalidAllProjectQueries(queryClient);
      toast.success('The project was canceled');
    },
    onError: (err) => {
      toastBackendError(err);
    },
  });
}
